import type { Language } from '@seek/melways-sites';

import type { PageConfig } from 'src/libs/PageConfig';
import type { FiltersEventCaptureData } from 'src/services/jobApplicationService/buildCaptureEventData';

import type { HighFitApplicationData, SearchFilters } from './types';

import type { IJobApplicationStore } from './index';

export const updateApplicationList = async (
  jobApplicationStore: IJobApplicationStore,
  initialLoad: boolean,
  language: Language,
  filters: SearchFilters,
  addCustomError: PageConfig['dataDogRum']['addCustomError'],
  jobPlacementExperimentVariant:
    | 'not_yet'
    | 'too_early_to_say'
    | 'still_reviewing_applications'
    | 'control',
  highFitApplicationData: HighFitApplicationData,
) => {
  const { uiState, lastResultSearchText, bucket, loadJobApplications } =
    jobApplicationStore;

  if (uiState.search) {
    if (uiState.search !== lastResultSearchText) {
      await loadJobApplications(
        {
          searchText: uiState.search,
          page: uiState.page,
          language,
          filters,
          addCustomError,
        },
        jobPlacementExperimentVariant,
        highFitApplicationData,
      );
    }
    return;
  }

  if (initialLoad || uiState.bucket !== bucket || lastResultSearchText !== '') {
    await loadJobApplications(
      {
        bucket: uiState.bucket,
        page: uiState.page,
        language,
        filters,
        addCustomError,
      },
      jobPlacementExperimentVariant,
      highFitApplicationData,
    );
  }
};

export const updatePage = async (
  jobApplicationStore: IJobApplicationStore,
  language: Language,
  filters: SearchFilters,
  addCustomError: PageConfig['dataDogRum']['addCustomError'],
  jobPlacementExperimentVariant:
    | 'not_yet'
    | 'too_early_to_say'
    | 'still_reviewing_applications'
    | 'control',
  highFitApplicationData: HighFitApplicationData,
) => {
  const { uiState, currentPage } = jobApplicationStore;

  if (uiState.page !== currentPage) {
    await jobApplicationStore.loadJobApplications(
      {
        page: uiState.page,
        language,
        filters,
        addCustomError,
      },
      jobPlacementExperimentVariant,
      highFitApplicationData,
    );
  }
};

export const updateSelectedDetails = async (
  jobApplicationStore: IJobApplicationStore,
  initialLoad: boolean,
  language: Language,
  filtersEventCaptureData: FiltersEventCaptureData,
  addCustomError: PageConfig['dataDogRum']['addCustomError'],
) => {
  const { uiState, showDetails, hideDetails } = jobApplicationStore;
  const { selectedProspectId, tab } = uiState;

  if (selectedProspectId) {
    await showDetails({
      id: selectedProspectId,
      language,
      initialLoad,
      tab,
      filtersEventCaptureData,
      addCustomError,
    });
  } else {
    hideDetails();
  }
};
